import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import fieldConfigurationModel from './fieldConfigurationModel.vue';
import { configList, configStore, getDesensitizePermission } from './request';
export default {
  components: {
    fieldConfigurationModel
  },
  props: ['id', 'type'],
  data() {
    return {
      data: [],
      value: [],
      columns: [{
        slots: {
          title: '菜单'
        },
        scopedSlots: {
          customRender: 'menu'
        },
        dataIndex: 'name',
        key: 'name'
      }],
      fieldConfigurationShow: false,
      selectedIndex: '',
      selectedIndex2: '',
      checkAll: false,
      customerDesensitizes: []
    };
  },
  created() {
    configList({
      customerId: this.id
    }, this.type).then(res => {
      res.map(item => {
        // if (item.position==1&&item.list) {
        item.list.map(item2 => {
          item2.allSelected = false;
          let arr = item2.permissionsGroup.filter(item3 => item3.selected);
          if (item2.permissionsGroup.length !== 0 && arr.length == item2.permissionsGroup.length) {
            item2.allSelected = true;
          }
        });
        // } else if (item.position == 1 && item.permissionsGroup) {

        // }
      });
      this.data = res;
      this.inspectAllFun();
    });
    // 获取客户角色脱敏是否展示
    console.log(this.id, 'this.id', this.type);
    if (this.id.length > 0 && this.type === 'customerRole') {
      // 客户角色
      let customerId = this.id.split(',')[1];
      getDesensitizePermission({
        customerId
      }).then(res => {
        console.log(res, 'res customerDesensitizes');
        this.customerDesensitizes = res;
      });
    }
  },
  methods: {
    desensitizeChange(item, e) {
      var _item$permissionsGrou;
      console.log(item, e);
      item.desensitize = e.target.checked;
      item === null || item === void 0 || (_item$permissionsGrou = item.permissionsGroup) === null || _item$permissionsGrou === void 0 || _item$permissionsGrou.map(item2 => {
        if (item2.associationId == 0) {
          item2.desensitize = e.target.checked;
        }
      });
    },
    onChange(e, arr, index) {
      var _arr$list$index, _arr$list$index2;
      e.selected = !e.selected;
      let num = e.associationId;
      if (num != 0) {
        // arr.list[index].permissionsGroup.map(item=>{
        //   if(item.id==num){
        //     item.selected=e.selected;
        //     if(item.associationId==0){
        //       arr.list[index].selected=e.selected;
        //     }
        //   }
        // })
      } else {
        // 判断permissionsGrouplength是否为0
        if (arr.list[index].permissionsGroup.length > 0) {
          arr.list[index].permissionsGroup.map(item => {
            if (item.associationId == 0) {
              arr.list[index].selected = e.selected;
            }
          });
        }
      }
      console.log(arr, index, '---------arr---------');
      let arr2 = (_arr$list$index = arr.list[index]) === null || _arr$list$index === void 0 ? void 0 : _arr$list$index.permissionsGroup.filter(item3 => item3.selected);
      if (arr2.length == ((_arr$list$index2 = arr.list[index]) === null || _arr$list$index2 === void 0 ? void 0 : _arr$list$index2.permissionsGroup.length)) {
        arr.list[index].allSelected = true;
      } else {
        arr.list[index].allSelected = false;
      }
      this.inspectAllFun();
    },
    onSubmit() {
      let permissionsData = [];
      let desensitize = [];
      this.data.map(item => {
        item.list.map(item2 => {
          item2.permissionsGroup.map(item3 => {
            if (item3.selected) {
              let info = item3.id;
              if (item3.associationId == 0 && item2.allowField.length != 0) {
                let num = [];
                item2.allowField.map(item4 => {
                  if (item4.selected && item4.allowField != 0) {
                    num.push(item4.id);
                  }
                });
                if (num.length != 0) {
                  info = String(info) + ':' + num.join(',');
                }
              }
              permissionsData.push(info);
            }
            // 取消脱敏数据
            if (item3.desensitize) {
              console.log(item3.id, 'item3.id');
              desensitize.push(item3.id);
            }
          });
        });
      });
      configStore({
        customerId: this.id,
        permissionsData: permissionsData.join('-'),
        desensitize: desensitize.join('-')
      }, this.type).then(res => {
        this.$message.success(this.$t('保存成功'));
        window.scrollTo(0, 0);
        this.$emit('ok', res);
      });
    },
    configureFun(arr, index, index2) {
      if (arr.length == 0) {
        this.$message.error(this.$t('没有可配置的字段'));
        return false;
      }
      this.fieldConfigurationShow = true;
      this.selectedIndex = index;
      this.selectedIndex2 = index2;
      this.$nextTick(() => {
        this.$refs.fieldConfiguration.init(arr);
      });
    },
    handleSure(arr) {
      this.data[this.selectedIndex].list[this.selectedIndex2].allowField = arr;
    },
    change2(index, data, type) {
      console.log(data, '--------data----------');
      data.allSelected = !data.allSelected;
      data.selected = data.allSelected;
      if (!type) {
        this.inspectAllFun();
      }
      if ((data === null || data === void 0 ? void 0 : data.permissionsGroup.length) > 0) {
        data === null || data === void 0 || data.permissionsGroup.map(item => {
          item.selected = data.allSelected;
        });
      }
    },
    onChangeAll() {
      this.checkAll = !this.checkAll;
      this.data.map((item, index) => {
        item.list.map((item2, index2) => {
          if (item2.allSelected == !this.checkAll) {
            this.change2(index, item2, true);
          }
        });
      });
    },
    inspectAllFun() {
      let arr = [];
      this.data.map(item => {
        arr = arr.concat(item.list);
      });
      let arr2 = arr.filter(item => item.allSelected);
      console.log(arr2, 22);
      this.checkAll = arr.length == arr2.length ? true : false;
    }
  }
};